export default __webpack_public_path__ + "static/media/icn-speed.814db75e.svg";